module.exports = __webpack_public_path__ + "media/images/home/mini/sc2-faf053237a3946501c16cb91cfe33234.png";